var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.fullScreen ? 'video-box' : ''},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player vjs-custom-skin",style:(_vm.styles),attrs:{"playsinline":true,"options":_vm.playerOptions()},on:{"loadeddata":_vm.onLoadedData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }